import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { formatInstalls } from 'marketplace-ui-common/utils/installs';
import { jsx as _jsx } from "react/jsx-runtime";
export function InstallBadge({
  installed,
  installCount
}) {
  if (installed) {
    return /*#__PURE__*/_jsx(StatusTag, {
      use: "success",
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trellisEcosystem.appCard.installed"
      })
    });
  }
  if (installCount !== undefined) {
    return /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      children: formatInstalls(installCount)
    });
  }
  return null;
}